import AuthService from '../../services/AuthService';
const Auth = new AuthService();



export function getOpenedEntretiens(id_salarie){
    return {
        type:"GET_OPENED_ENTRETIENS",
        payload: Auth.fetch('/societe/opened_entretiens/'+id_salarie)
    }
}

export function getAllEntretiens(){
    return {
        type:"GET_ALL_ENTRETIENS",
        payload: Auth.fetch('/salarie/entretiens')
    }
}

export function getInfosSalarie(){
    return {
        type:"GET_INFOS_SALARIE",
        payload: Auth.fetch('/salarie/infos')
    }
}


// WEBPACK FOOTER //
// ./src/actions/salarie/actions_salarie_1.js